import React, { useEffect, useState } from "react";
import "./Upload.css";
import { styled } from "@mui/material/styles";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { IconButton, TextField } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { config } from "../../core/service/config.service";

const Input = styled("input")({
  display: "none"
});

export default function Upload(props) {
  const { photo, photoName } = props;
  const formikProps = useFormikContext();
  const [profileImg, setProfileImg] = useState(
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
  );
  // const [photoField, photoMeta] = useField(photo);

  useEffect(()=>{
    //console.log('profileImg', formikProps?.values?.photo?.file)
    if(photoName){
      setProfileImg(`${config.host_api}user/photo/${photoName}`)
      //formikProps?.values?.photo?.file
    }
  },[])

  

  const imageHandler = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setProfileImg(reader.result);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  return (
    <div className="page">
      <div className="container">
        <div className="img-holder">
          <img src={profileImg} alt="" id="img" className="img" />
        </div>
        <input
          type="file"
          inputProps={{
            accept: "image/x-png,image/jpeg"
          }}
          name="image-upload"
          id="input"
          onChange={(event) => {
            formikProps.setFieldValue(
              `photo.file`,
              event.currentTarget.files[0]
            );
            imageHandler(event);
          }}
        />
        <div className="label">
          <label htmlFor="input">
            <Input
              inputProps={{
                accept: "image/x-png,image/jpeg"
              }}
              type="file"
              name={photo.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `photo.file`,
                  event.currentTarget.files[0]
                );
              }}
            />
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <PhotoCamera />
            </IconButton>
            Choose your Photo
          </label>
        </div>
      </div>
    </div>
  );
}
